import { useEffect, useMemo, useRef, useState } from 'react'
import { useSelector } from 'react-redux'
import { selectCurrentUser } from '@user/store/authorization/userSlice'
import { BillTo, useSearchBillTos } from '@user/store/entityLocations'

export const TAKE_SIZE = 20

export const useData = () => {
  const [selectedBillToId, setSelectedBillToId] = useState<string>()
  const [open, setOpen] = useState(false)
  const [allBillTos, setAllBillTos] = useState<BillTo[]>([])

  // Tracking refs
  const loadingRef = useRef(false)
  const [isFetchingMore, setIsFetchingMore] = useState(false)

  const currentUser = useSelector(selectCurrentUser)

  const branchIds = useMemo(
    () => (currentUser.isAdmin ? '' : currentUser.branches?.map((b) => b.id)),
    [currentUser.branches, currentUser.isAdmin],
  )

  const {
    count,
    items,
    loading,
    onChangePage,
    onChangeSearchText,
    onClearSearchText,
    page,
    pages,
    searchText,
  } = useSearchBillTos('', TAKE_SIZE, branchIds)

  // Sync ref
  useEffect(() => {
    loadingRef.current = loading
    if (!loading) {
      setIsFetchingMore(false)
    }
  }, [loading])

  // Manage accumulated items
  useEffect(() => {
    if (page === 1) {
      if (items) {
        setAllBillTos(items)
      }
    } else if (items && items.length > 0) {
      setAllBillTos((prev) => {
        const newIds = new Set(items.map((i) => i.id))
        return [...prev.filter((p) => !newIds.has(p.id)), ...items]
      })
    }
  }, [items, page])

  // Reset/Open logic based on search
  useEffect(() => {
    if (!searchText) {
      setAllBillTos([])
      setOpen(false)
    } else {
      setOpen(true)
    }
  }, [searchText])

  return {
    selectedBillToId,
    setSelectedBillToId,
    open,
    setOpen,
    allBillTos,
    isFetchingMore,
    setIsFetchingMore,
    loadingRef,
    count,
    loading,
    onChangePage,
    onChangeSearchText,
    onClearSearchText,
    page,
    pages,
    searchText,
  }
}
